import React from 'react';
import {Navigate, NavLink, useOutletContext, useParams} from 'react-router-dom';
import StatusIcon, {StaleSyncWarning, StatusLegend} from '../../../components/StatusIcon';
import BacServer from '../forms/BacServer';
import TmsSettings from '../forms/TmsSettings';
import SettingsPanel from './SettingsPanel';
import MediablockPanel from './MediablockPanel';

const SystemsTab = () => {
    const { organizationId } = useParams();
    const { organization, bacView, handleUpdate } = useOutletContext();

    if (!bacView) {
        return <Navigate to="../overview" replace />;
    }

    return (
        <div>
            <MediablockPanel organization={organization} bacView={bacView} handleUpdate={handleUpdate} />

            <SettingsPanel
                icon="fa-server"
                title="BAC Server status"
                summary={
                    <>
                        <div className="me-5 text-center">
                            <span>ALFRED:</span>
                            <StatusIcon type="daemon" value={organization.bacServer?.gofilexDaemonsAlfred} showLabel className="ms-2" />
                        </div>
                        <div className="me-3 text-center">
                            <span>FRANK:</span>
                            <StatusIcon type="daemon" value={organization.bacServer?.gofilexDaemonsFrank} showLabel className="ms-2" />
                        </div>
                        <StaleSyncWarning lastSynced={organization.lastSynced} />
                    </>
                }
            >
                <BacServer
                    initialSettings={organization.bacServer}
                    onSave={handleUpdate('bacServer')}
                />
            </SettingsPanel>

            <SettingsPanel
                icon="fa-gears"
                title="TMS Settings"
                summary={
                    <>
                        Edit TMS Settings
                        <StatusIcon type="tms" value={organization?.tmsSettings?.status} showLabel className="ms-2" />
                        <StaleSyncWarning lastSynced={organization.lastSynced} className="ms-2" />
                    </>
                }
            >
                <TmsSettings
                    initialSettings={organization.tmsSettings}
                    onSave={handleUpdate('tmsSettings')}
                />
            </SettingsPanel>

            <NavLink
                to={`/organizations/${organizationId}/content`}
                className="d-flex position-relative border-start border-primary bg-broken details-card align-items-center mb-3 text-decoration-none text-white"
            >
                <span
                    className="fas fa-fw fa-file-video bg-broken position-absolute align-items-center d-flex justify-content-center text-primary"/>
                <div>
                    <p className="mb-0 text-uppercase text-primary">
                        Content Manager
                        <span className="fas fa-eye ms-2 edit-icon"/>
                    </p>
                    View available content on Mediablock and BAC server
                </div>
            </NavLink>

            <NavLink to={`/organizations/${organizationId}/cues`} className="text-decoration-none text-white">
                <div
                    className="d-flex position-relative border-start border-primary bg-broken details-card align-items-center mb-3">
                    <span
                        className="fas fa-fw fa-robot bg-broken position-absolute align-items-center d-flex justify-content-center text-primary"/>
                    <div>
                        <p className="mb-0 text-uppercase text-primary">
                            Automation cues
                            <span className="fas fa-pencil ms-2 edit-icon"/>
                        </p>
                        <div className="d-flex align-items-center gap-1 mt-1">
                            Edit Default Playlist for this organization
                        </div>
                    </div>
                </div>
            </NavLink>

            <StatusLegend />
        </div>
    );
};

export default SystemsTab;
